export const initialState = {
  cart: false,
  modal: false,
  secondaryNavigation: false,
  mobileNavigation: false,
};
